/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Job_Detail_Meeting_Link_AddInputs */

const en_company_job_detail_meeting_link_add = /** @type {(inputs: Company_Job_Detail_Meeting_Link_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add meeting link`)
};

const de_company_job_detail_meeting_link_add = /** @type {(inputs: Company_Job_Detail_Meeting_Link_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meeting-Link hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add meeting link" |
*
* @param {Company_Job_Detail_Meeting_Link_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_job_detail_meeting_link_add = /** @type {((inputs?: Company_Job_Detail_Meeting_Link_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Job_Detail_Meeting_Link_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_job_detail_meeting_link_add(inputs)
	return en_company_job_detail_meeting_link_add(inputs)
});